import Duck from 'extensible-duck';
import {
  LOADING_INIT_DATA,
  LOAD_DATA_FULL_SUCCESS,
  LOAD_INIT_DATA_SUCCESS,
} from '../actions/api-actions';
import {
  getDynamicAndStaticData,
  isExpiredTrip,
  isInvalidTrip,
} from '../common/utils/trip';

const initialState = {
  driverInfo: {
    fullname: '',
    profileSrc: '',
    rating: 0,
  },
  vehicleInfo: {
    license: '',
    make: '',
    model: '',
  },
  contact: {
    phone: '',
    voipId: '',
    chatRoomId: '',
  },
};

export default new Duck({
  namespace: 'ge-delivery',
  store: 'driver',
  initialState,
  selectors: duck => ({
    driver: state => state[duck.store],
  }),
  reducer: (state, action) => {
    switch (action.type) {
      case LOADING_INIT_DATA:
        return initialState;

      case LOAD_INIT_DATA_SUCCESS:
      case LOAD_DATA_FULL_SUCCESS: {
        const { data } = action;

        if (isInvalidTrip(data) || isExpiredTrip(data)) return state;
        const { webTrackingDetails } = data;

        const { staticData } = getDynamicAndStaticData(webTrackingDetails[0]);

        if (!staticData.driver) return null;

        const {
          firstName,
          lastName,
          profile,
          rating,
          vehicle,
          phone,
          voipID,
        } = staticData.driver;

        return {
          ...state,
          driverInfo: {
            fullname: [firstName, lastName].join(' '),
            profileSrc: profile,
            rating,
          },
          vehicleInfo: vehicle,
          contact: {
            phone,
            voipId: voipID,
            chatRoomId: staticData.chatRoomID,
          },
        };
      }

      default:
        return state;
    }
  },
});
